import React from 'react';

// Styled Components
import styled from 'styled-components';

// Bootstrap Imports
import Container from 'react-bootstrap/Container';

// Styled Components
const AboutHeaderContainer = styled.div`
	background: url('/img/conocenos.jpg') no-repeat;
	background-size: cover;
	background-position: 250px -280px;
	width: 100%;
	height: 40vh;
	position: relative;

	@media (max-width: 768px) {
		background: url('/img/conocenos.jpg') no-repeat;
		background-size: cover;
		background-position: center;
		width: 100%;
		height: 40vh;
		position: relative;
	}
`;

const AboutHeader = () => {
	return (
		<AboutHeaderContainer>
			<div
				style={{
					position: 'absolute',
					top: 0,
					width: '100%',
					height: '100%',
					backgroundImage:
						'linear-gradient( 120deg, rgb(119 115 214) 20%, rgb(214 118 255 / 0%))',
					color: '#fff',
				}}>
				<Container className='about-text-container d-flex align-items-center ml-md-5 mr-md-0 pl-2 p-md-0'>
					<h1 className='about-title mb-md-0 pl-md-5'>
						Con nuestro enfoque digital y de aprendizaje, te ayudamos a crecer,
						poniendo tu negocio en otro nivel con un tinte creativo
					</h1>
				</Container>
			</div>
		</AboutHeaderContainer>
	);
};

export default AboutHeader;
